export default __webpack_public_path__ + "static/media/03.f4027ba8.png";